<template>
  <v-card
    color="rgb(0, 0, 0, 0)"
    flat
    class="mt-3 pa-2 pt-0 mb-0 zoom-class"
    style="height: 100%"
    :style="{ 'background-color': $vuetify.theme.isDark ? '#1E1E1E' : '' }"
  >
    <v-row class="mx-0">
      <v-col cols="12" md="3" class="pe-2 px-0">
        <aicomplete
          v-model="template"
          title=""
          type="statusTemplate"
          :outlined="false"
          :new-btn="true"
          :set-init="true"
          :val="template"
          flat
          outlined
          dense
        />
      </v-col>
      <v-col cols="12" md="3" class="pe-2 px-0">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clearable
          :label="$t('search')"
          :loading="isLoading"
          flat
          outlined
          dense
        />
      </v-col>
      <v-spacer />
      <v-menu v-if="isMobile || isTablet" offset-y>
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            outlined
            class="mt-2 px-1"
            color="grey darken-2"
            height="32"
            v-bind="attrs"
            v-on="on"
            style="min-width: 35px !important; padding: 0 !important"
          >
            <!-- <p class="mb-0 me-2">
              {{$t('more')}}
            </p> -->
            <v-icon> mdi-dots-vertical </v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item v-if="isMobile || isTablet" link @click="getItems">
            <v-list-item-icon>
              <v-icon>mdi-refresh</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refresh')" />
          </v-list-item>
          <v-list-item
            v-if="isMobile || isTablet"
            link
            @click="openComponent('task', null)"
          >
            <v-list-item-icon>
              <v-icon>mdi-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('task')" />
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="getItems"
        class="mt-2 px-1 ms-2"
        color="grey darken-2"
        height="32"
        style="min-width: 35px !important; padding: 0 !important"
        @shortkey="getItems"
        v-shortkey="['f5']"
        :loading="isLoading"
      >
        <!-- <p class="mb-0 me-2">
          {{$t('refresh')}}
        </p> -->
        <v-icon> mdi-refresh </v-icon>
      </v-btn>
      <v-btn
        outlined
        @click="filter = true"
        class="mt-2 ms-2"
        color="grey darken-2 "
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("filter") }}
        </p>
        <v-icon> mdi-filter-outline </v-icon>
      </v-btn>
      <v-btn
        v-if="!isMobile && !isTablet"
        outlined
        @click="openComponent('task', null)"
        class="mt-2 ms-2"
        color="primary"
        height="32"
      >
        <p class="font-weight-thin mb-0 me-2">
          {{ $t("task") }}
        </p>
        <v-icon> mdi-plus </v-icon>
      </v-btn>
    </v-row>
    <v-row class="ma-0 mt-2 scroll">
      <v-col
        v-for="(item, index) in items"
        :key="index"
        class="pe-4 px-0"
        style="width: 350px; display: inline-block; vertical-align: top"
      >
        <v-banner
          slot="header"
          elevation="0"
          class="mb-3 custom"
          role="group"
          :style="'border: 1px solid ' + item.color"
          single-line
          style="border-radius: 4px"
        >
          <div class="d-flex gap-1">
            {{ item.name }}
            <v-spacer />
            <v-chip
              v-if="item.list && item.list.length > 0 && item.list[0].id > 0"
              :color="item.color"
              outlined
              small
              class="custom"
              style="padding: 0 12px"
            >
              {{ item.total }}
            </v-chip>
            <v-chip
              :color="item.color"
              outlined
              small
              class="custom"
              style="padding: 0 6px; cursor: pointer"
              @click="openCreateTask('task', null, item, template)"
            >
              <v-icon size="15">mdi-plus</v-icon>
            </v-chip>
          </div>
        </v-banner>
        <draggable
          v-model="item.list"
          data-source="juju"
          class="list-group task-wrapper"
          handle=".handle"
          v-bind="dragOptions"
          group="a"
          :style="{
            'max-height': item.descVisibility
              ? 'calc(100vh - 307px)'
              : 'calc(100vh - 210px)',
          }"
          @start="drag = true"
          @end="drag = false"
          @change="change(item.id, $event)"
        >
          <transition-group type="transition" :name="!drag ? 'flip-list' : null">
            <v-hover
              v-for="(element, i) in item.list"
              :key="element.ref && element.ref.id ? element.ref.id : 'empty-' + item.id"
              v-slot="{ hover }"
            >
              <v-container
                class="wrapper-task"
                :class="{ 'only-child': item.list.length == 1 }"
              >
                <div :dd="hover" class="">
                  <p v-if="element.id === 0">
                    {{ element.name }}
                  </p>
                  <v-card
                    v-if="element.id > 0"
                    class="mt-0 mb-0"
                    :class="[
                      $vuetify.theme.isDark ? 'dark-board-card' : 'light-board-card',
                      '',
                    ]"
                  >
                    <v-card-title
                      style="font-size: 12px; cursor: pointer"
                      @click="editTask('task', element.ref)"
                    >
                      {{ element.ref.title }}
                      <v-spacer />
                      <v-chip
                        v-if="element.ref.due_end_date"
                        label
                        dark
                        x-small
                        :color="element.ref.timeRemianing.day < 0 ? 'primary' : 'pink'"
                        @click="openTaskDialog(element.ref)"
                      >
                        {{ element.ref.timeRemianing.date }}
                      </v-chip>
                      <div v-if="element.ref.participants" class="ml-2 mr-2">
                        <v-avatar
                          v-for="(participant, i) in element.ref.participants"
                          :key="i"
                          :color="participant.user.color"
                          size="40"
                          style="margin-left: -14px; border: white 2px solid"
                        >
                          <img
                            v-if="participant.user.avatar"
                            :src="participant.user.avatar.link"
                            alt="John"
                          />
                          <span v-if="!participant.user.avatar" style="color: white">
                            {{ participant.user.firstname.charAt(0) }}
                            {{
                              participant.user.lastname
                                ? participant.user.lastname.charAt(0)
                                : ""
                            }}
                          </span>
                        </v-avatar>
                      </div>
                    </v-card-title>
                    <v-card-text style="font-size: 12px" class="py-2 pt-0 px-3">
                      <div>
                        <v-chip
                          v-for="(tag, index) in element.ref.tags"
                          :key="index"
                          :color="tag.color"
                          label
                          small
                          style="margin-left: 1px; margin-right: 1px"
                          class="px-1 mb-1"
                        >
                          <span class="px-1 white--text">
                            {{ tag.text }}
                          </span>
                        </v-chip>
                      </div>
                      <div v-if="element.relation">
                        <v-chip
                          color="info"
                          x-small
                          style="margin-left: 1px; margin-right: 1px"
                          class="px-1 mb-1"
                          @click="openRelationLink(element)"
                        >
                          <v-icon style="font-size: 12px"> mdi-link-variant </v-icon>
                          <span class="px-1 white--text">
                            {{ element.relation.name }}
                          </span>
                        </v-chip>
                      </div>
                      <div v-if="element.ref.functor">
                        <v-chip
                          :color="element.ref.functor.color"
                          x-small
                          style="margin-left: 1px; margin-right: 1px"
                          class="px-1 mb-1"
                        >
                          <v-icon style="font-size: 12px"> mdi-link-variant </v-icon>
                          <span class="px-1 white--text">
                            {{ $t("functor") }} : {{ element.ref.functor.name }}
                          </span>
                        </v-chip>
                      </div>
                      <div v-if="element.ref.creator">
                        <v-chip
                          :color="element.ref.creator.color"
                          x-small
                          style="margin-left: 1px; margin-right: 1px"
                          class="px-1 mb-1"
                        >
                          <v-icon style="font-size: 12px"> mdi-plus-circle </v-icon>
                          <span class="px-1 white--text">
                            {{ $t("maker") }} : {{ element.ref.creator.name }}
                          </span>
                        </v-chip>
                      </div>
                      <!-- chip relation-->
                      <div
                        v-if="
                          element?.relation?.meta?.branch &&
                          element.relation.meta.branch != null
                        "
                      >
                        <v-chip
                          color="#6A1B9A"
                          x-small
                          style="margin-left: 1px; margin-right: 1px"
                          class="px-1 mb-1"
                        >
                          <v-icon style="font-size: 12px"> mdi-link-variant </v-icon>
                          <span class="px-1 white--text">
                            {{ $t("branch-name") }} :
                            {{ element?.relation?.meta?.branch?.name }}
                          </span>
                        </v-chip>
                      </div>
                      <div
                        v-if="
                          element?.relation?.meta?.referral_code &&
                          element?.relation?.meta?.referral_code != null
                        "
                      >
                        <v-chip
                          color="#EF6C00"
                          x-small
                          style="margin-left: 1px; margin-right: 1px"
                          class="px-1 mb-1"
                        >
                          <v-icon style="font-size: 12px"> mdi-link-variant </v-icon>
                          <span class="px-1 white--text">
                            {{ $t("referral-code") }}:
                            {{ element?.relation?.meta?.referral_code }}
                          </span>
                        </v-chip>
                      </div>
                    </v-card-text>
                    <v-card-actions class="py-0">
                      <div v-if="hover">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="primary"
                              v-bind="attrs"
                              x-small
                              icon
                              class="me-1"
                              v-on="on"
                              @click="share(element.ref)"
                            >
                              <v-icon small color="primary">
                                mdi-share-variant-outline
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t("share") }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="primary"
                              v-bind="attrs"
                              x-small
                              icon
                              class="me-1"
                              v-on="on"
                              @click="copyTask('task', element.ref)"
                            >
                              <v-icon small color="primary"> mdi-content-copy </v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t("copy") }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-if="doneId != element.status_id && item.state !== 'done'"
                              color="green"
                              v-bind="attrs"
                              x-small
                              icon
                              class="me-1"
                              v-on="on"
                              @click="setDoneStatus(element.ref)"
                            >
                              <v-icon small> mdi-check </v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t("setDone") }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-if="element.ref.link"
                              color="grey"
                              v-bind="attrs"
                              small
                              icon
                              v-on="on"
                              @click="openLink(element)"
                            >
                              <v-icon small> mdi-link-variant </v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t("link") }}</span>
                        </v-tooltip>
                        <!--                      <v-tooltip
                            bottom
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                color="blue"
                                v-bind="attrs"
                                x-small
                                icon
                                v-on="on"
                                @click="openTaskDialog(element.ref)"
                              >
                                <v-icon
                                  small
                                >
                                  mdi-eye-outline
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t('show') }}</span>
                          </v-tooltip>-->
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="blue"
                              v-bind="attrs"
                              x-small
                              icon
                              class="ml-1"
                              v-on="on"
                              @click="opemDeleteDialog(element.ref)"
                            >
                              <v-icon small color="pink"> mdi-trash-can-outline </v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t("remove") }}</span>
                        </v-tooltip>
                      </div>
                      <v-spacer />
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="indigo lighten-4"
                            v-bind="attrs"
                            small
                            text
                            class="px-0 handle"
                            v-on="on"
                          >
                            {{ element.ref.time }}
                          </v-btn>
                        </template>
                        <span>{{
                          element && element.user ? element.user.name : ""
                        }}</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            color="grey darken-2"
                            class="handle ms-2"
                            style="font-size: 22px"
                            v-on="on"
                          >
                            mdi-sort
                          </v-icon>
                        </template>
                        <span>{{ $t("sortTaskMessage") }}</span>
                      </v-tooltip>
                    </v-card-actions>
                  </v-card>
                  <div
                    v-if="item.lastPage > 1 && item.list.length == i + 1 && item.loader"
                    v-observe-visibility="{
                      callback: (isVisible, entry) =>
                        visibilityChanged(isVisible, entry, item),
                    }"
                    class="text-center"
                  >
                    <v-progress-circular
                      :size="20"
                      :width="2"
                      color="primary"
                      indeterminate
                    />
                  </div>
                </div>
              </v-container>
            </v-hover>
          </transition-group>
        </draggable>
        <div
          class="footer-task"
          style="
            background: #c0c0c042;
            padding: 10px;
            border-top-right-radius: 0;
            border-top-left-radius: 0;
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
          "
        >
          <v-textarea
            v-if="item.descVisibility"
            v-model="item.description"
            :placeholder="$t('enter-title')"
            outlined
            auto-grow
            :ref="'desc-' + item.id"
            class="desc-textarea mb-1"
            rows="3"
            style="outline: none; border: none; width: 100%; background-color: #fff"
            max-rows="6"
            @keydown.enter="submitTaskPreview(item, $event)"
          />
          <v-btn
            v-if="!item.descVisibility"
            outlined
            class="w-100"
            color="primary"
            height="32"
            @click="openDescColumn(item)"
          >
            {{ $t("task") }}
            <v-icon size="15">mdi-plus</v-icon>
          </v-btn>
          <div class="d-flex gap-2 mt-2" v-if="item.descVisibility">
            <v-btn
              color="primary"
              height="32"
              :loading="isLoading"
              @click="submitTaskPreview(item, $event)"
              style="width: 40%"
            >
              {{ $t("add-task") }}
            </v-btn>
            <v-btn color="error" height="32" icon @click="item.descVisibility = false">
              <v-icon size="20">mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    <dialog-component
      :dialog-prop="innerComponent"
      :data-prop="dialogData"
      @close="innerComponent = false"
      @fetchBoard="onBoardFetch"
    />
    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon class="close-hover" @click="taskDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="filter = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("filter") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col cols="12" md="4">
            <status v-model="taskStatus" :hideconfig="true" :multiple="true" />
          </v-col>
          <v-col cols="12" md="4">
            <tag v-model="tag" />
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="functor"
              title="functor"
              type="partners"
              :filter="true"
              :multiple="false"
            />
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="fromId"
                v-model="fromDate"
                :label="$t('from') + ' ' + $t('createDate')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="fromDate"
                element="fromId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="toId"
                v-model="toDate"
                :label="$t('until') + ' ' + $t('createDate')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="toDate"
                element="toId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromDate"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="registerar"
              title="registerar"
              type="partners"
              :filter="true"
            />
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="fromIdUpdate"
                v-model="fromDateUpdate"
                :label="$t('from') + ' ' + $t('dateUpdate')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="fromDateUpdate"
                element="fromIdUpdate"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="toIdUpdate"
                v-model="toDateUpdate"
                :label="$t('until') + ' ' + $t('dateUpdate')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="toDateUpdate"
                element="toIdUpdate"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromDate"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <autocomplete
              v-model="participants"
              title="participants"
              type="partners"
              :filter="true"
              :multiple="true"
            />
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="fromIdDue"
                v-model="fromDueDate"
                :label="$t('from') + ' ' + $t('dueDate')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="fromDueDate"
                element="fromIdDue"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col cols="12" md="4">
            <template>
              <v-text-field
                id="toIdDue"
                v-model="toDueDate"
                :label="$t('until') + ' ' + $t('dueDate')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="toDueDate"
                element="toIdDue"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromDate"
                auto-submit
                :color="
                  this.$vuetify.theme.themes[
                    this.$vuetify.theme.isDark ? 'dark' : 'light'
                  ].primary
                "
                @close="setDate"
              />
            </template>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col class="px-0" cols="6">
              <v-btn class="mx-0" color="primary" @click="getItems">
                {{ $t("filter") }}
              </v-btn>
            </v-col>
            <v-col class="px-0" cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-task") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import draggable from "vuedraggable";
import aicomplete from "../../components/general/AIcomplete/index";
import General from "@/Mixins/general";
const message = ["vue.draggable", "draggable"];
export default {
  name: "TaskDesk",
  display: "Transitions",
  order: 7,
  components: {
    draggable,
    Tag: () => import("../../components/general/Tag/tag"),
    Status: () => import("../../components/general/Status/status"),
    aicomplete,
    dialogComponent: () => import("../../components/general/dialog/index"),
  },
  mixins: [General],
  data() {
    return {
      list: message.map((name, index) => {
        return { name, id: index + 1 };
      }),
      list2: message.map((name, index) => {
        return { name, id: index + 1 };
      }),
      items: [],
      toDueDate: null,
      fromDueDate: null,
      toDateUpdate: null,
      fromDateUpdate: null,
      dialogData: null,
      taskId: null,
      deleteItem: null,
      functor: null,
      deletDialog: null,
      fromDate: null,
      toDate: null,
      template: null,
      timer: null,
      tag: null,
      taskStatus: null,
      isLoading: false,
      innerComponent: null,
      search: null,
      filter: null,
      refId: null,
      taskDialog: null,
      doneId: null,
      activeNames: null,
      drag: false,
      registerar: null,
      participants: null,
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 250,
        // group: 'description',
        disabled: false,
        ghostClass: "ghost",
      };
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
  },
  watch: {
    template() {
      if (this.template) {
        this.getItems();
      }
      localStorage.setItem("taskTemplate", JSON.stringify(this.template));
    },
    items(val) {
      if (val) {
        if (!this.doneId) {
          var k = this.items.findIndex((x) => x.state === "done");
          this.doneId = this.items[k].id;
        }
        this.$nextTick(() => {
          setTimeout(() => {
            this.checkWrapperScrollbar();
          }, 10);
        });
      }
    },
    taskDialog() {
      if (!this.taskDialog) {
        this.getItems();
      }
    },
    search() {
      var app = this;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
  },
  mounted() {
    var template = localStorage.getItem("taskTemplate");
    if (template && template !== undefined) {
      this.template = JSON.parse(template);
    }
  },
  activated: function () {
    this.getItems();
  },
  methods: {
    checkWrapperScrollbar() {
      const wrappers = document.querySelectorAll(".task-wrapper");
      wrappers.forEach((wrapper) => {
        const hasScrollbar = wrapper.scrollHeight > wrapper.clientHeight;
        // wrapper.classList.toggle('has-scroll', hasScrollbar)
        if (wrapper.parentElement) {
          wrapper.parentElement.classList.toggle("has-scroll", hasScrollbar);
        }
      });
    },
    share(elm) {
      var app = this;
      if (navigator.share) {
        navigator.share({
          title: elm.title,
          text: "",
          url: "" + app.$HostName + "/task/edit/" + elm.id,
        });
      } else {
      }
    },
    editTask(component, item) {
      this.dialogData = {
        name: component,
        id: item.id,
      };
      this.innerComponent = true;
      // this.$router.push({ name: 'taskEdit', params: { id: item.id, tabName: item.title } })
    },
    copyTask(component, item) {
      this.dialogData = {
        name: component,
        id: item.id,
        copy: true,
      };
      this.innerComponent = true;
      // this.$router.push({ name: 'task', params: { id: item.id, tabName: item.title, copy: true } })
    },
    visibilityChanged(e, entry, item) {
      e && this.getTask(item);
    },
    opemDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    remove() {
      var app = this;
      if (!app.deleteItem) return false;
      app.loading = true;
      app.$axios
        .delete(this.$endpoint + "task/" + this.deleteItem.id)
        .then((res) => {
          res = res.data;
          app.deleteItem = null;
          this.deletDialog = false;
          app.getItems();
        })
        .finally(() => (app.loading = false));
    },
    openLink(item) {
      window.open(item.ref.link, "_blank");
    },
    openTaskDialog(item) {
      if (item) {
        this.refId = item.rel_id;
        this.taskId = item.id;
      } else {
        this.refId = null;
        this.taskId = null;
      }
      this.taskDialog = true;
    },
    openRelationLink(item) {
      if (item.ref.type === "account") {
        this.$router.push({ name: "customerEdit", params: { id: item.relation.id } });
      }
      if (item.ref.type === "invoice") {
        this.$router.push({
          name: item.relation.type + "Edit",
          params: { id: item.relation.uid },
        });
      }
    },
    edit(id) {
      this.$router.push({ name: "SellEdit", params: { id: id } });
    },
    getTask(item) {
      var app = this;
      app.isLoading = true;
      if (item.page + 1 > item.lastPage) {
        setTimeout(function () {
          item.loader = false;
        }, 1000);
        return false;
      }
      item.page = parseInt(item.page) + parseInt(1);
      app.$axios
        .get(this.$endpoint + "task", {
          params: {
            getTaskBoard: true,
            status_id: item.id,
            page: item.page,
            template_id: app.template.id,
            taskStatus: app.taskStatus,
            search: app.search,
            taskStatus: app.taskStatus,
            tag: app.tag,
            functor: app.functor,
            fromDate: app.fromDate,
            toDate: app.toDate,
            fromDateUpdate: app.fromDateUpdate,
            toDateUpdate: app.toDateUpdate,
            fromDueDate: app.fromDueDate,
            toDueDate: app.toDueDate,
          },
        })
        .then((res) => {
          res = res.data;
          item.list = [...item.list, ...Array.from(res.data)];
        })
        .catch((err) => {
          var error = err.response;
          if (error.status === 500) {
          }
          if (error.status === 401) {
            app.$router.push({ name: "logout" });
          }
        })
        .finally(() => (app.isLoading = false));
    },
    onBoardFetch(payload) {
      if (payload && payload.mode === "update" && payload.id) {
        this.updateTaskInPlace(payload);
        return;
      }
      this.getItems();
    },
    updateTaskInPlace(payload) {
      var fromCol = null;
      var fromIdx = -1;

      this.items.forEach((col) => {
        var i = (col.list || []).findIndex((el) => el.ref && el.ref.id === payload.id);
        if (i > -1) {
          fromCol = col;
          fromIdx = i;
        }
      });

      if (!fromCol) return;

      var card = fromCol.list[fromIdx];
      if (card.ref) {
        card.ref.title = payload.title;
        this.$set(card.ref, "tags", payload.tag);
        this.$set(card.ref, "functor", payload.functor);
        this.$set(card.ref, "participants", payload.participants);
        this.$set(card.ref, "due_end_date", payload.dueDate);
        this.$set(card.ref, "link", payload.link);
      }
      this.$set(card, "relation", payload.relation);

      var newStatusId = payload.status && payload.status.id;
      if (!newStatusId || newStatusId === fromCol.id) return;

      var toCol = this.items.find((c) => c.id === newStatusId);
      if (!toCol) return;

      fromCol.list.splice(fromIdx, 1);
      if (fromCol.list.length === 0) {
        fromCol.list.push({ name: this.$t("clear-item-here"), id: 0 });
      }
      if (fromCol.total > 0) fromCol.total--;

      var emptyIdx = (toCol.list || []).findIndex((x) => x.id === 0);
      if (emptyIdx > -1) toCol.list.splice(emptyIdx, 1);

      card.status_id = newStatusId;
      toCol.list.unshift(card);
      toCol.total = (toCol.total || 0) + 1;
    },
    getItems() {
      var app = this;
      app.isLoading = true;
      app.filter = false;
      app.$axios
        .get(this.$endpoint + "status/show", {
          params: {
            template_id: app.template.id,
            taskStatus: app.taskStatus,
            tag: app.tag,
            search: app.search,
            toDueDate: app.toDueDate,
            fromDueDate: app.fromDueDate,
            toDateUpdate: app.toDateUpdate,
            fromDateUpdate: app.fromDateUpdate,
            fromDate: app.fromDate,
            functor: app.functor,
            toDate: app.toDate,
            board: "yes",
            type: "sell",
            user_id: app.registerar,
            participants: app.participants,
          },
        })
        .then((res) => {
          app.items = res.data;
          app.items.forEach((i) => {
            this.$set(i, "descVisibility", false);
          });
          // app.items.map(function (val, key) {
          //   // val.list = app.list
          //   app.getList(val, key)
          // })
        })
        .catch((err) => {
          var error = err.response;
          if (error.status === 500) {
          }
          if (error.status === 401) {
            app.$router.push({ name: "logout" });
          }
        })
        .finally(() => (app.isLoading = false));
    },
    openDescColumn(item) {
      this.items.forEach((i) => (i.descVisibility = false));
      item.descVisibility = true;
      this.$nextTick(() => {
        const el = this.$refs["desc-" + item.id];
        if (el && el[0]) {
          el[0].focus();
        }
      });
    },
    submitTaskPreview(item, e) {
      // If Shift is held, just allow the newline to be inserted
      if (e.shiftKey) return;

      // Prevent the default “insert newline” that the browser would do.
      e.preventDefault();

      if (item.description == null) {
        return false;
      }
      var app = this;
      app.isLoading = true;
      app.$axios
        .post(this.$endpoint + "task", {
          status: {
            type: item.type,
            id: item.id,
            name: item.name,
            state: item.state,
            template_id: item.template_id,
            color: item.color,
          },
          title: item.description,
        })
        .then((res) => {
          app.getItems();
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          // app.isLoading = false
        });
    },
    getList(status, key) {
      var app = this;
      app.isLoading = true;
      app.$axios
        .get(this.$endpoint + "status/show", {
          params: {
            board: "yes",
            status_id: status.id,
            type: "sell",
          },
        })
        .then((res) => {
          var data = res.data.data;
          app.items[key].list = [];
          data.map(function (val) {
            app.items[key].list.push(val);
          });
        })
        .finally(() => (app.isLoading = false));
    },
    sort() {
      this.list = this.list.sort((a, b) => a.order - b.order);
    },
    change(add, eve) {
      if (Object.keys(eve)[0] === "added") {
        var i = this.items.findIndex((x) => x.id === add);
        var j = this.items[i].list.findIndex((x) => x.id === 0);
        if (j > -1) {
          this.items[i].list.splice(j, 1);
        }
        this.changeStatus(
          add,
          eve.added.element.type,
          eve.added.element.ref_id,
          eve.added.element
        );
      }
      if (Object.keys(eve)[0] === "removed") {
        var index = this.items.findIndex((x) => x.id === add);
        if (this.items[index].list.length === 0) {
          this.items[index].list.push({ name: this.$t("clear-item-here"), id: 0 });
        }
      }
      if (Object.keys(eve)[0] === "moved") {
        var k = this.items.findIndex((x) => x.id === add);
        this.changeSort(this.items[k].list);
      }
    },
    changeStatus(statusId, type, refId, elm) {
      var app = this;
      app.isLoading = true;
      app.$axios
        .post(this.$endpoint + "status/change", {
          id: refId,
          type: "task",
          status: statusId,
        })
        .then((res) => {
          elm.status_id = statusId;
          app.getItems();
        })
        .catch((err) => {
          var error = err.response;
          if (error.status === 500) {
          }
          if (error.status === 401) {
            app.$router.push({ name: "logout" });
          }
        })
        .finally(() => (app.isLoading = false));
    },
    changeSort(list) {
      var app = this;
      app.isLoading = true;
      app.$axios
        .post(this.$endpoint + "status/sort", {
          list: list,
        })
        .then((res) => {})
        .catch((err) => {
          var error = err.response;
          if (error.status === 500) {
          }
          if (error.status === 401) {
            app.$router.push({ name: "logout" });
          }
        })
        .finally(() => (app.isLoading = false));
    },
    setDoneStatus(item) {
      var k = this.items.findIndex((x) => x.state === "done");
      this.changeStatus(this.items[k].id, item.type, item.id, item);
    },
    inputChanged(value) {
      this.activeNames = value;
    },
    openComponent(component, id) {
      this.dialogData = {
        name: component,
        id: id,
      };
      this.innerComponent = true;
    },
    openCreateTask(component, id, currentStatus, template) {
      this.dialogData = {
        name: component,
        id: id,
        customStatus: currentStatus,
        board: template,
      };
      this.innerComponent = true;
    },
    // openTaskDialog () {
    //   if (this.$refs.refTask) {
    //     this.$refs.refTask.clearForm()
    //   }
    //   this.taskDialog = true
    // },
  },
};
</script>

<style scoped>
.has-scroll .footer-task {
  padding-left: 21px !important;
}
.v-chip.custom ::v-deep .v-chip__content {
  align-items: normal;
}
.v-banner.custom ::v-deep .v-banner__wrapper {
  padding: 7px 10px;
}
.list-group .wrapper-task {
  background: #c0c0c042;
  padding: 10px !important;
  border-radius: 0;
  padding-top: 0 !important;
}
.list-group .wrapper-task:nth-child(1) {
  padding-top: 10px !important;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.list-group .wrapper-task.only-child {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.desc-textarea ::v-deep .v-text-field__details {
  display: none;
}
.desc-textarea ::v-deep .v-input__slot textarea {
  max-height: calc(1.5em * 6);
  overflow-y: auto;
  resize: none;
}
.desc-textarea ::v-deep .v-input__slot {
  padding-left: 15px !important;
  padding-right: 15px !important;
  margin-bottom: 0;
}
.desc-textarea ::v-deep .v-input__slot textarea::-webkit-scrollbar {
  width: 8px;
}
.desc-textarea ::v-deep .v-input__slot textarea::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 4px;
  margin-top: -9px;
  margin-bottom: 1px;
}
.desc-textarea ::v-deep .v-input__slot textarea::-webkit-scrollbar-thumb {
  background-color: #c0c0c0;
  border-radius: 4px;
  border: 2px solid #f0f0f0;
}
.desc-textarea ::v-deep .v-input__slot textarea::-webkit-scrollbar-thumb:hover {
  background-color: #999999;
}
.list-group-item {
  position: relative;
  display: block;
  min-width: 600px;
  padding: 0.75rem 1.25rem;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #e1e1e1;
}
.light-board-card {
  background-color: #ffffff !important;
  /* border: 1px solid #e0e0e0 !important; */
}
.dark-board-card {
  border: 1px solid #6f6f6f !important;
}
.dark-board-background {
  background-color: #1e1e1e !important;
}
.scroll {
  display: block;
  height: 95%;
  white-space: nowrap;
  position: relative;
  overflow-x: scroll;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch !important;
}

.outer div {
  width: 24.5%;
  background-color: #eee;
  float: none;
  height: 90%;
  margin: 0 0.25%;
  display: inline-block;
  zoom: 1;
}
/*.scroll::-webkit-scrollbar {*/
/*  width: 5px !important;*/
/*}*/

/*.scroll::-webkit-scrollbar-track {*/
/*  background-color: #e4e4e4;*/
/*  border-radius: 5px;*/
/*  width: 10px;*/
/*}*/

/*.scroll::-webkit-scrollbar-thumb {*/
/*  border-radius: 5px;*/
/*  !*border: 6px solid rgba(0, 0, 0, 0.18);*!*/
/*  border-left: 0;*/
/*  border-right: 0;*/
/*  background-color: #cfcfcf;*/
/*  width: 10px;*/
/*}*/
.scroll::-webkit-scrollbar {
  width: 8px;
}
.scroll::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-left: 1px solid #dadada;
  width: 8px;
}

.scroll::-webkit-scrollbar-thumb {
  background: #dadada;
  border: solid 3px #f5f5f5;
  border-radius: 7px;
  width: 8px;
}

.scroll::-webkit-scrollbar-thumb:hover {
  background: #9b9b9b;
}
.theme--light.v-banner.v-sheet:not(.v-sheet--outlined):not(.v-sheet--shaped)
  .v-banner__wrapper {
  border-bottom: 0px solid rgba(0, 0, 0, 0) !important;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
}
</style>
